import { generateReadOneActionCreator, generateUpdateActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';

export default {
    readCampaignContacts: generateReadOneActionCreator(routes.API_CAMPAIGN, ACTION_NAMES.CAMPAIGN_CONTACTS, 'contacts'),
    updateContactStatus: generateUpdateActionCreator(routes.API_CAMPAIGN, ACTION_NAMES.CAMPAIGN_CONTACTS, () => {}, () => {}, 'contacts'),
    readTextableContacts: generateReadOneActionCreator(routes.API_CAMPAIGN, ACTION_NAMES.TEXT_CAMPAIGN_CONTACTS, 'text_contacts'),
}
